import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap"; 

import * as apiUrl from "../../apiUrl";

function OurteamChairman() {
  const [ChairmanMessage, setChairmanMessage] = useState({});

  useEffect(() => {
    const fetchChairmanMessage = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/our-team/chairman-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setChairmanMessage(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchChairmanMessage();
  }, []);

  const descriptions = ChairmanMessage.section_description
    ? JSON.parse(ChairmanMessage.section_description)
    : [];

  return (
    <section className="ourteam-chairman-sec">
      <Container fluid>
        <Row className="flex-center ourteam-chairman-row">
          <Col md={6} className="ourteam-chairman-content-col">
            <img
              src={`${apiUrl.apiUrl}/${ChairmanMessage.section_image}`}
              className="img-fluid"
              alt="Marquis Property Developer"
              data-aos="fade-right"
            />
          </Col>
          <Col md={6} className="ourteam-chairman-content-col">
            <div
              className="ourteam-chairman-content-div"
              data-aos="fade-left"
            >
              <h2 className="common-head greyColor">
                {ChairmanMessage.section_title}
              </h2>

              {descriptions.map((description, index) => (
                <p className="common-para" key={index}>
                  {descriptions[index]}
                </p>
              ))}

              <h3 className="common-head greyColor">
                {" "}
                {ChairmanMessage.section_sub_title}{" "}
              </h3>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default OurteamChairman;
